/**
 *
 * Sort
 *
 */

import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin: 0 3px;
`;

/* eslint-disable react/prefer-stateless-function */
export const Sort = function(props) {
  return (
    <Container className="sort" onClick={props.onClick}>
      <img src={`/public/images/sort_${props.direction || 'none'}.svg`} height="15" />
    </Container>
  );
};
